import HeaderInfo from './HeaderInfo';

export default HeaderInfo;
